import React from 'react';
import {BonusMark} from './BonusBoardArt';
const {isBonus}=require('../utils/competitionRules');
const { resultWordBands } = require('../utils/resultWordBands');
const { nextWordAtCell } = require('../utils/resultWordRanges');
export default function ResultWordBoard({ html, size, words, selectedIndex, onSelect, name }) {
  const { bands } = resultWordBands(words, size, selectedIndex);
  const tapCell = event => {
    const cell = event.target.closest('.result-board > div > div');
    if (!cell || !event.currentTarget.contains(cell)) return;
    const row = Array.from(cell.parentElement.parentElement.children).indexOf(cell.parentElement);
    const col = Array.from(cell.parentElement.children).indexOf(cell);
    onSelect(nextWordAtCell(words, size, row, col, selectedIndex));
  };
  const box = band => ({
    x: band.range.left * 100 + 14, y: band.range.top * 100 + 14,
    width: (band.range.right - band.range.left + 1) * 100 - 28,
    height: (band.range.bottom - band.range.top + 1) * 100 - 28
  });
  return <div className="result-word-board relative mx-auto w-full max-w-[400px]" onClick={tapCell} aria-label={`${name} sonuç tahtası`}>
    {size===8&&<div className="result-bonus-overlay-r41" aria-hidden="true">{Array.from({length:64},(_,i)=><span key={i}>{isBonus(Math.floor(i/8),i%8)&&<BonusMark compact/>}</span>)}</div>}
    <svg viewBox={`0 0 ${size * 100} ${size * 100}`} preserveAspectRatio="none" className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true">
      {bands.map(band => <rect key={band.index} {...box(band)} rx="16" fill={band.color} fillOpacity={selectedIndex == null || selectedIndex === band.index ? 0.12 : 0.06} />)}
    </svg>
    <div className="result-board relative w-full" style={{ '--result-board-size': size }} dangerouslySetInnerHTML={{ __html: html || '' }} />
    <svg viewBox={`0 0 ${size * 100} ${size * 100}`} preserveAspectRatio="none" className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true">
      {bands.map(band => <rect key={band.index} {...box(band)} rx="16" fill="none" stroke={band.color}
        strokeWidth={selectedIndex === band.index ? 6 : 3.5} strokeOpacity={selectedIndex == null || selectedIndex === band.index ? 0.85 : 0.4} />)}
      {bands.map(({ index, range, horizontal, color }) => <g key={`number:${index}`} transform={`translate(${range.left * 100 + (horizontal ? 23 : 77)}, ${range.top * 100 + 19})`}>
        <rect x="-15" y="-13" width="30" height="26" rx="8" fill="white" stroke={color} strokeWidth="2" />
        <text textAnchor="middle" dominantBaseline="central" fontSize="19" fontWeight="800" fill={color}>{index + 1}</text>
      </g>)}
    </svg>
  </div>;
}
